import React, { useMemo } from 'react'
import { PaidMarketingDataStyled } from 'Features/accountSettings/components/Billing/TrialPreEndModal/PaidMarketingData/PaidMarketingData.styled'
import { InvalidRequests } from 'Features/accountSettings/components/Billing/TrialPreEndModal/Components/InvalidRequests/InvalidRequests'
import { ThreatGroupsPm } from 'Features/accountSettings/components/Billing/TrialPreEndModal/Components/ThreatGroupsPm/ThreatGroupsPm'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { DEFAULT_TIMEZONE, getCountryLabelByCountryValue, toUnixDateRangeFix } from 'Utils/dates'
import { kFormatter } from 'Utils/number'
import { TotalVisits } from '../Components/TotalVisits/TotalVisits'
import { BlockingActivityPm } from '../Components/BlockingActivityPm/BlockingActivityPm'
import { useGetPlatforms } from 'Features/domainsManagement/api/getPlatforms'
import { useVisitsSummary } from 'Features/home/api/getVisitsSummary'

export const PaidMarketingData = () => {
  const { timezoneCountry } = useUserStore()
  const { data: plansDetails } = useGetPlansDetails()
  const { data: platforms } = useGetPlatforms({})

  const platformsConnected = useMemo(() => {
    return platforms?.some((platform) => {
      return platform.enabled
    })
  }, [platforms])

  const timezone: string = getCountryLabelByCountryValue(timezoneCountry)
  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })

  const { data: visitsData } = useVisitsSummary(
    {
      startDate: serverDateConversion?.from,
      endDate: serverDateConversion?.to,
      timezone: timezone || DEFAULT_TIMEZONE,
    },
    !!timezoneCountry && !!plansDetails
  )

  return (
    <PaidMarketingDataStyled>
      <TotalVisits totalVisits={kFormatter(visitsData?.[0].paidTraffic) || ''} />
      <InvalidRequests invalidRequests={kFormatter(visitsData?.[0].paidInvalidTraffic) || ''} />
      {platformsConnected}
      {platformsConnected ? <BlockingActivityPm /> : <ThreatGroupsPm />}
    </PaidMarketingDataStyled>
  )
}
